import React from 'react';
import {paths} from '../common/dictionaries/urls';
import AgenciesManagement from './components/index';

export const agenciesRoutes = [
  {'component': <AgenciesManagement />, 'path': paths.AgenciesManagement},
];
